import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PageCTA } from '../components/PageCTA';
import { CheckCircle2 } from 'lucide-react';
export function ProcessPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const steps = [{
    number: '01',
    title: 'Auditoría y Estrategia',
    description: 'Análisis profundo y hoja de ruta técnica diseñada para maximizar tu penetración en el mercado.'
  }, {
    number: '02',
    title: 'Diseño de Interfaces (UI/UX)',
    description: 'Arquitecturas visuales calculadas para reducir fricción y guiar al usuario hacia la conversión.'
  }, {
    number: '03',
    title: 'Ingeniería y Desarrollo',
    description: 'Código limpio y escalable con frameworks modernos para tiempos de respuesta milisegundos.'
  }, {
    number: '04',
    title: 'Sincronización de Nodos',
    description: 'Interconectamos todas las plataformas para crear un flujo de datos ininterrumpido.'
  }, {
    number: '05',
    title: 'Despliegue y Escalabilidad',
    description: 'Lanzamiento controlado con monitoreo en tiempo real. Maquinaria lista para operar.'
  }];
  const differentiators = [{
    title: 'Ingeniería orientada a Conversión',
    description: 'Interfaces basadas en datos para maximizar el LTV.',
    metric: '+120% LTV'
  }, {
    title: 'Arquitecturas Holísticas',
    description: 'Ecosistemas donde todo opera bajo una misma lógica.',
    metric: '100% Sincronizado'
  }, {
    title: 'Escalabilidad por Diseño',
    description: 'Patrones de software para soportar demanda exponencial.',
    metric: 'Cero Caídas'
  }, {
    title: 'Fricción Cero',
    description: 'Transiciones fluidas desde descubrimiento a transacción.',
    metric: '-40% Rebote'
  }, {
    title: 'Métricas que Importan',
    description: 'Éxito cuantificado en facturación y reducción de costos.',
    metric: 'ROI Medible'
  }];
  return <div className="pt-24 bg-[#0a0a0a] min-h-screen" data-id="element-618">
      {/* Page Header */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-619">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl text-center" data-id="element-620">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-621">
            <h1 className="text-4xl md:text-5xl font-medium text-white mb-6 tracking-tight" data-id="element-622">
              Cómo Transformamos Tu Negocio
            </h1>
            <p className="text-lg text-gray-400 leading-relaxed font-normal max-w-2xl mx-auto" data-id="element-623">
              Nuestra metodología está diseñada para llevar tu negocio al mundo
              digital de forma estructurada, profesional y sin dolores de cabeza
              para ti.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-624">
        <div className="container mx-auto px-6 md:px-12 max-w-3xl" data-id="element-625">
          <div className="space-y-4" data-id="element-626">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="card-premium p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-627">
                <div className="text-2xl font-light text-gray-600 shrink-0" data-id="element-628">
                  {step.number}
                </div>
                <div data-id="element-629">
                  <h3 className="text-lg font-medium text-white mb-1" data-id="element-630">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-400 leading-relaxed" data-id="element-631">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Differentiation */}
      <section className="py-20 border-b border-white/[0.05]" data-id="element-632">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl" data-id="element-633">
          <div className="mb-12" data-id="element-634">
            <h2 className="text-2xl font-medium text-white mb-3 tracking-tight" data-id="element-635">
              Por qué Growthly es diferente
            </h2>
            <p className="text-gray-400 text-sm" data-id="element-636">
              Nos alejamos del modelo tradicional de agencia. No hacemos
              "trabajos", construimos activos digitales.
            </p>
          </div>

          <div className="card-premium !overflow-hidden divide-y divide-white/[0.05]" data-id="element-637">
            {differentiators.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-[#131313] transition-colors" data-id="element-638">
                <div data-id="element-639">
                  <h3 className="text-sm font-medium text-white mb-1" data-id="element-640">
                    {point.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-641">{point.description}</p>
                </div>
                <div className="shrink-0" data-id="element-642">
                  <span className="badge-premium !text-[11px] !uppercase !tracking-wider" data-id="element-643">
                    {point.metric}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <PageCTA data-id="element-644" />
    </div>;
}